import { Link } from "react-router-dom";

export default function ProjectListItem( { item,  backgroundPosition = "center" } ){
    let name = item.title;
    let type = item.type;
    let thumbnail = item.thumbnail;

    // let categoriesList = categories?.map(item => item.name).join(", ");
    
    return(
        <div style = { { paddingBottom : "40px", } } >
            <Link to = {`/works/${item.id}`} style = { { textDecoration : "none" } }>
                <div className = "projectThumbnail" style = { { backgroundImage : `url(${thumbnail})`, backgroundSize : "cover", backgroundPosition : backgroundPosition, display : "block" }}/>

                <div className = "projectsCaption"
                    style = { { display : "flex", gap : "4px" } }>
                    <p className = "heading" style = { { lineHeight : "110%", color : "var(--black80)" } }>{ name }</p>
                    <div className = "projectsCaptionLine" style = { { flex : 1, height : "0.5px" } }/>
                    <p style = { { fontSize : "9px", color : "var(--black80)", fontWeight : "500" } }>{ type }</p>
                </div>
            </Link>
        </div>
    )
}